import { schemes, zSchema } from "../../schema-validation";
import { EAccrualPolicyType, ERolloverType } from "../types";

export const accrualPolicySchema = zSchema.object({
  id: schemes.mongoObjectId(),
  code: zSchema.string(),
  name: zSchema.string(),
  type: zSchema.nativeEnum(EAccrualPolicyType),
  effective_date: zSchema.string(),
  workers_count: zSchema.number(),
  accrual_rate: zSchema.number(),
  accrual_period: zSchema.number(),
  accrual_waiting_period: zSchema.number().optional(),
  accrual_cap: zSchema.number().optional(),
  rollover_date: zSchema.string().optional(),
  rollover_cap: zSchema.number().optional(),
  rollover_type: zSchema.nativeEnum(ERolloverType).optional(),
  include_overtime: zSchema.boolean(),
  include_doubletime: zSchema.boolean(),
  immediate_balance: zSchema.number().optional(),
  include_flat: zSchema.boolean().optional(),
  workers: zSchema.array(schemes.mongoObjectId()),
});

export type TAccrualPolicy = zSchema.infer<typeof accrualPolicySchema>;
